import config from '@/config';
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
import createDOMPurify from 'dompurify';
const sanitizer = createDOMPurify();
sanitizer.addHook('afterSanitizeAttributes', currentNode => {
    if ('target' in currentNode) {
        // Open all links in new tab / window
        currentNode.setAttribute('target', '_blank');
        // To prevent legacy browsers to pass confidential info across the link...
        // https://developer.chrome.com/docs/lighthouse/best-practices/external-anchors-use-rel-noopener
        currentNode.setAttribute('rel', 'noopener noreferrer');
    }
});
export const useGetTaskDocumentation = (taskTemplateId, enabled) => {
    const intl = useIntl();
    const { data, isLoading, error, refetch } = useQuery([TaskQueryKey.TaskDocumentation, taskTemplateId], () => {
        return api.base
            .get(`${config.appUrls.tasks}/api/taskTemplates/Documentation/${taskTemplateId}`)
            .then(({ data: documentation }) => ({
            documentation: sanitizer.sanitize(documentation || ''),
        }));
    }, {
        enabled,
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
    return {
        data,
        error,
        isLoading,
        refetch,
    };
};
